import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class RenderLevelComponent extends Component {
  @service session;
  get levelObj() {
    const livelli_sci = this.args.topLevel || this.session.option_field?.livelli_sci;
    const color = this.args.color;

    if (!Array.isArray(livelli_sci) || !color) {
      return {
        color: color,
      };
    }

    const livello_sci = this.trovaLivelloSci(color, livelli_sci);

    if (!livello_sci) {
      return {
        color: color,
      };
    }

    livello_sci.showText = this.session.option_field?.show_text_on_level && !livello_sci?.hide_text;

    return livello_sci;
  }

  trovaLivelloSci(color, livelli) {
    function cercaInSottoLivelli(color, sottoLivelli) {
      return sottoLivelli.find((sotto) => sotto.colorName === color) || null;
    }

    for (const livello of livelli) {
      if (livello.colorName === color) {
        return livello;
      }

      if (Array.isArray(livello.sotto_livelli)) {
        const sottoLivello = cercaInSottoLivelli(color, livello.sotto_livelli);
        if (sottoLivello) {
          return sottoLivello;
        }
      }
    }
    return null;
  }
}
